module.exports = __webpack_public_path__ + "img/mes-scene-electronics.353bb84f.jpg";